import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const { init, fetching } = createAllActions(types.SCOPE);

const fetchData = (dimension) => ({
  type: types.FETCH_DATA,
  dimension,
});

const initDimension = (dimension) => ({
  type: types.INIT_DIMENSION,
  dimension,
});

const setupDimension = ({ dimension, dimensionStore }) => ({
  type: types.SETUP_DIMENSION,
  dimension,
  dimensionStore,
});

const setDimension = (widgetIndex, dimensionIndex, dimension) => ({
  type: types.SET_DIMENSION,
  widgetIndex,
  dimensionIndex,
  dimension,
});

const unsetDimension = (dimension) => ({
  type: types.UNSET_DIMENSION,
  dimension,
});

const setResponse = ({ dimension, response, errorMsg }) => ({
  type: types.SET_RESPONSE,
  dimension,
  response,
  errorMsg,
});

const setBenchmarkResponse = ({ dimension, response, errorMsg }) => ({
  type: types.SET_BENCHMARK_RESPONSE,
  dimension,
  response,
  errorMsg,
});

const setLoadingState = (dimension, loadingState) => ({
  type: types.SET_LOADING_STATE,
  dimension,
  loadingState,
});

export {
  init,
  fetching,
  fetchData,
  initDimension,
  setupDimension,
  setDimension,
  unsetDimension,
  setResponse,
  setBenchmarkResponse,
  setLoadingState,
};
